import { redirect } from 'react-router-dom';
import { httpGet } from '../../store/externalCalls/httpCalls';
import { createSession } from '../../store/actions/sessionActions';
import store from '../../store/store';

const getAppSlugFromPath = (pathname) => {
  const segments = pathname.split('/').filter(Boolean);
  const wlplayIndex = segments.indexOf('wlplay');

  if (wlplayIndex === -1) return null;

  return segments[wlplayIndex + 1] || null;
};

export const appManagerLoader = async ({ request }) => {
  const dispatch = store.dispatch;
  const currentSession = store.getState()?.session || {};

  try {
    const url = new URL(request.url);
    const pathname = url.pathname.replace(/\/+/g, '/');
    const appSlugFromPath = getAppSlugFromPath(pathname);

    if (!appSlugFromPath) {
      return {
        app: null,
        spaceName: null,
        appId: null,
        appSlug: null,
        appConfigSlug: null,
        areaId: null,
        appConfigs: [],
        params: {},
      };
    }

    const response = await httpGet(`loader?path=${encodeURIComponent(pathname)}`);
    if (response?.redirectTo) {
      return redirect(response.redirectTo);
    }

    const app = response?.app ?? null;
    const appConfigs = Array.isArray(response?.appConfigs) ? response.appConfigs : [];
    const params = response?.params ?? {};
    const spaceName = response?.spaceName ?? app?.name ?? null;
    const appSlug = params?.appSlugName ?? app?.slug ?? null;
    const configSlugName = params?.configSlugName ?? null;
    if (!app?.id || !appSlug) {
      return redirect('/wlplay');
    }

    const appId = parseInt(app.id, 10);

    const sessionConfigId = currentSession.areaId;
    let validSessionConfig =
      appConfigs.find((config) => String(config.name) === String(configSlugName)) ||
      appConfigs.find((config) => String(config.id) === String(sessionConfigId)) ||
      null;

    if (!validSessionConfig && appConfigs.length > 0) {
      validSessionConfig = appConfigs[0];
    }
    const areaId = validSessionConfig?.id ?? null;
    const configSlug = validSessionConfig?.name ?? null;

    dispatch(createSession({
      spaceName,
      appId,
      appSlug,
      appConfigSlug: configSlug,
      ...(areaId !== null ? { areaId: areaId } : {}),
    }));

    let notFound = response?.notFound ?? false;
    return {
      app,
      spaceName,
      appId,
      appSlug,
      appConfigSlug: configSlug,
      areaId,
      appConfigs,
      params,
      notFound
    };
  } catch (e) {
    return redirect('/wlplay');
  }
}